// extracted by mini-css-extract-plugin
module.exports = {"ApplicationFormTable":"style_ApplicationFormTable__3kT5x"};